import React from "react";
import { Button, Col, Empty, Row } from "antd";
import { useHistory } from "react-router-dom";

export default function DashboardPage(props) {
  const history = useHistory();
  return (
    <Row>
      <Col span={24}>
        <Empty
          style={{
            color: "white",
            width: "100%",
            marginTop: "50px",
          }}
          description="No data!"
        >
          <Button
            type="primary"
            onClick={() => history.push("/dashboard/projects")}
          >
            Go to Projects
          </Button>
        </Empty>
      </Col>
    </Row>
  );
}
